$(document).ready(function() {
    
    $(".radios").radiosToSlider({
        animation: true // false to disable the animation.
    });
    var staticPrompt = $('#health-quiz-prompt');
    stickyPrompt = "fixed-prompt";
    hdr = $('header').height();
    topText = $('#health-quiz-intro').height();
    var promptHeight = staticPrompt.height();
    
    $(window).scroll(function() {
        if( $(this).scrollTop() > (hdr + topText) ) {
            staticPrompt.addClass(stickyPrompt);
            $("#health-quiz-questions").css({"margin-top":promptHeight+"px"});
            $("#health-quiz-prompt").css({"background-color":"#315778"});
            $("#health-quiz-rate").css({"background-color":"#D5E2ED"});
        } else {
            staticPrompt.removeClass(stickyPrompt);
            $("#health-quiz-questions").css({"margin-top": "0px"});
            $("#health-quiz-prompt").css({"background-color":"inherit", "color":"inherit"});
            $("#health-quiz-rate").css({"background-color":"inherit"});
        }
    });
    function mobileViewUpdate() {
        var viewportWidth = $(window).width();
        if (viewportWidth < 991) {
            $(".rate-wrap > div:first-child").removeClass("pull-right");
        }
        else {
            $(".rate-wrap > div:first-child").addClass("pull-right");
        }
    }
    mobileViewUpdate();
    $(window).resize(mobileViewUpdate);

});